import { render } from "./email-create-message.vue?vue&type=template&id=6bde3955&scoped=true"
import script from "./email-create-message.vue?vue&type=script&lang=js"
export * from "./email-create-message.vue?vue&type=script&lang=js"

import "./email-create-message.vue?vue&type=style&index=0&id=6bde3955&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bde3955"]])

export default __exports__